<template>
  <div>
    <section>
      <div class="container text-center">
        <img src="@/assets/img/404.gif" class="img-fluid" alt="Error-404" />
        <h4 class="font-weight-bold">Uh-oh!</h4>
        <p class="font-weight-bold">We couldn't find what you were looking for.</p>

        <!-- <div class="proceed-btn mx-auto text-center">
          <b-button to="" type="button" name id class="btn py-md-2 px-md-5">Load More</b-button>
        </div>-->
        <router-link class="btn-gogo mx-auto" to="/">Go to Home</router-link>
        <img src="@/assets/img/svg/SeparatorOR.svg" class="img-fluid my-4" />
        <h6>Browse through our catalogue</h6>
      </div>
    </section>

    <!-- NOW SHOWING MOVIES SLIDER -->
    <section>
      <div class="container-fluid my-5">
        <NowShowing />
      </div>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";
import NowShowing from "@/components/partials/nowShowingSlider.vue";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";

export default {
  name: "homepage",
  components: {
    Slick,
    NowShowing
  }
};
</script>

<style>
/* .movieCat .txt-link {
    display: none;
  }

  .movieCat .link {
    display: inline-block !important;
  }

  .NowShowingSlider .link {
    display: none;
  } */
</style>



// WEBPACK FOOTER //
// src/components/pages/error404.vue